var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-6 divide-y divide-gray-200"},[_c('div',{staticClass:"px-4 sm:px-6"},[_vm._v("Coming soon.")])])}]

export { render, staticRenderFns }